<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

import NavbarComponent from '@/components/NavbarComponent.vue'
import OnboardingDashboardPanel from '@/components/onboarding/OnboardingDashboardPanel.vue'
import StepCard from '@/components/onboarding/StepCard.vue'
import OnboardingPopup from '@/components/OnboardingPopup.vue'
import Sidebar from '@/components/Sidebar.vue'
import { adBlockerSuspected } from '@/lib/services/ad-blocker.service'
import { BoxComponent } from '@/ui-library'

const store = useStore()
const welcomeImage = new URL('@/assets/welcome-popUp.png', import.meta.url).href
const advertiser = computed(() => store.getters['shop/shop'])
const onboardingState = computed(() => store.state.onboarding)
const isDirectStore = computed(() => store.getters['shop/isDirectStore'])
</script>
<template>
  <StepCard v-if="onboardingState.showOnboardingDashboard && isDirectStore" v-show="!adBlockerSuspected" />
  <Sidebar />
  <NavbarComponent />
  <BoxComponent :ml-lg="80" :ml="0">
    <div class="container">
      <BoxComponent v-if="advertiser.paymentType === 'stripe' && advertiser.stripeSubscriptionStatus === 'inactive'" :mt="24">
        <el-alert type="error" :closable="false" title="You subscription is inactive"
          >Please reach out to <a href="mailto:support@metapic.com">support@metapic.com</a> to reactivate
        </el-alert>
      </BoxComponent>
      <OnboardingDashboardPanel v-if="onboardingState.showOnboardingDashboard && advertiser.isDirectStore" />
    </div>
    <OnboardingPopup
      v-if="onboardingState.showOnboardingWelcomePopup && advertiser.isDirectStore"
      v-show="!adBlockerSuspected"
      :img="welcomeImage"
      h="Welcome to Metapic!"
      p="Explore the welcome tour and follow four simple steps to set up your account for success on the Metapic platform."
      cancel-btn="Skip"
      main-btn="Show me around"
      @cancel-click="
        () => {
          store.commit('onboarding/CLOSE_WELCOME_ONBOARDING_POPUP')
          store.dispatch('onboarding/showOnboardingClosePopup')
        }
      "
      @xmark-click="store.commit('onboarding/CLOSE_WELCOME_ONBOARDING_POPUP')"
      @main-click="store.commit('onboarding/CLOSE_WELCOME_ONBOARDING_POPUP')"
    />
    <OnboardingPopup
      v-if="onboardingState.isConfirmClosePopupShown"
      v-show="!adBlockerSuspected"
      h="Are you sure you would like to close welcome dashboard?"
      p="Brands that complete these steps are the most likely to find success with Metapic."
      cancel-btn="Cancel"
      main-btn="Close dashboard"
      @cancel-click="store.dispatch('onboarding/hideOnboardingClosePopup')"
      @xmark-click="store.dispatch('onboarding/hideOnboardingClosePopup')"
      @main-click="store.commit('onboarding/CLOSE_ONBOARDING_DASHBOARD')"
    />
    <slot />
  </BoxComponent>
</template>
